import { supabase } from '@/integrations/supabase/client';

export const markMessageAsRead = async (messageId: string, userId: string) => {
  try {
    const { error } = await supabase
      .from('messages')
      .update({ is_read: true })
      .eq('id', messageId)
      .eq('receiver_id', userId);

    if (error) {
      console.error('Error marking message as read:', error);
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error:', error);
    return false;
  }
};

export const markMessagesAsRead = async (messageIds: string[], userId: string, onSuccess?: () => void) => {
  try {
    
    // D'abord, vérifier les messages avant la mise à jour
    const { data: beforeData, error: beforeError } = await supabase
      .from('messages')
      .select('id, is_read, receiver_id')
      .in('id', messageIds);
    
    if (beforeError) {
      console.error('Error fetching messages before update:', beforeError);
      return false;
    }
    
    const { data, error } = await supabase
      .from('messages')
      .update({ is_read: true })
      .in('id', messageIds)
      .eq('receiver_id', userId)
      .select('id, is_read');

    if (error) {
      console.error('Error marking messages as read:', error);
      return false;
    }
    
    // Appeler le callback de succès si fourni
    if (onSuccess) {
      onSuccess();
    }
    
    return true;
  } catch (error) {
    console.error('Error:', error);
    return false;
  }
};
